import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { formatSearchFilterContentCount } from '@app/search/components/search-view/search-reactive-store/utils';
import { SearchFilterFilter } from '@app/search/search-api.model';
import { SimpleItemViewModel } from '@app/shared/models/core-view.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'dgx-search-filter-sidebar-options',
  templateUrl: './search-filter-sidebar-options.component.html',
  styleUrls: ['./search-filter-sidebar-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchFilterSidebarOptionsComponent {
  @Input() public filter: SearchFilterFilter;

  @Output() public filterChange = new EventEmitter<SearchFilterFilter>();

  constructor(private route: ActivatedRoute) {}

  public showCount({ model: { count } }: SimpleItemViewModel) {
    return (
      count > -1 &&
      (this.filter.id !== 'Type' ||
        this.route.snapshot.queryParams.isMarketplaceCat)
    );
  }

  public getContentCount({ model: { count } }: SimpleItemViewModel) {
    return formatSearchFilterContentCount(count);
  }

  public toggleSelected({ isSelected, model: { id } }: SimpleItemViewModel) {
    const subitems = this.filter.subitems.map((item) => {
      if (item.model.id === id) {
        item.isSelected = !isSelected;
      }

      return item;
    });

    this.filterChange.emit({
      ...this.filter,
      subitems,
    });
  }
}
